export default {
  category: null,
  name: null,
  pib: null,
}
